import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { APP_THEME } from "../theme/theme";
import AppFooter from "../components/app-footer";
import BottomNav from "../components/bottom-menu";
import { apiCall } from "../utils/api";
import toast, { Toaster } from 'react-hot-toast';
import { GoVerified, GoUnverified } from "react-icons/go";

const menuItems = [
    {
        label: "Edit Profile",
        path: "/profile-edit",
        icon: (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
    },
    {
        label: "Refer & Earn",
        path: "/refer-code",
        icon: (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 12 20 22 4 22 4 12" /><rect x="2" y="7" width="20" height="5" /><line x1="12" y1="22" x2="12" y2="7" /></svg>,
    },
    {
        label: "Transaction History",
        path: "/history",
        icon: (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>,
    },
    {
        label: "Rate Us",
        path: "#",
        icon: (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>,
    },
    {
        label: "Write to Us",
        path: "#",
        icon: (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>,
    },
    {
        label: "Help & Support",
        path: "/support-center",
        icon: (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" /></svg>,
    }
];

const policyItems = [
    {
        id: 'terms',
        label: "Terms & Conditions",
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 8 9" />
            </svg>
        ),
        description: "Read our terms of service",
        url: APP_THEME.policyUrls?.terms || "#",
    },
    {
        id: 'privacy',
        label: "Privacy Policy",
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
            </svg>
        ),
        description: "How we protect your data",
        url: APP_THEME.policyUrls?.privacy || "#",
    },
    {
        id: 'refund',
        label: "Refund Policy",
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 12a9 9 0 1 1-9-9" />
                <polyline points="15 6 21 12 15 18" />
                <line x1="12" y1="12" x2="21" y2="12" />
            </svg>
        ),
        description: "Get your money back",
        url: APP_THEME.policyUrls?.refund || "#",
    },
    {
        id: 'cancellation',
        label: "Cancellation Policy",
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="18" y1="6" x2="6" y2="18" />
            </svg>
        ),
        description: "Cancel your transactions",
        url: APP_THEME.policyUrls?.cancellation || "#",
    },
    {
        id: 'account-deletion',
        label: "Account Deletion",
        icon: (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="17" y1="9" x2="22" y2="14" />
                <line x1="22" y1="9" x2="17" y2="14" />
            </svg>
        ),
        description: "Request account deletion",
        url: APP_THEME.policyUrls?.accountDeletion || "#",
    },
];

function ProfileDetails() {
    const navigate = useNavigate();
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [shadow, setShadow] = useState(false);
    const [balance, setBalance] = useState(localStorage.getItem("balance") || "0.00");
    const [showRatingModal, setShowRatingModal] = useState(false);
    const [selectedRating, setSelectedRating] = useState(0);
    const [hoveredRating, setHoveredRating] = useState(0);
    const [feedbackText, setFeedbackText] = useState("");

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const result = await apiCall("profile-fetch", {}, true);
                if (result.status === true) {
                    setProfile(result.profile);
                } else {
                    toast.error(result.message || "Failed to fetch profile");
                }
            } catch (error) {
                toast.error("Network error. Please try again.");
            } finally {
                setLoading(false);
            }
        }

        const fetchBalance = async () => {
            try {
                const result = await apiCall("balance", {}, true);
                if (result.status === true) {
                    setBalance(result.data.balance);
                    localStorage.setItem("balance", result.data.balance)
                } else {
                    toast.error(result.message || "An error occurred. Please try again.");
                }
            } catch (error) {
                toast.error("Network error. Please try again.");
            }
        }

        fetchProfile();
        fetchBalance();
    }, [])

    useEffect(() => {
        const handleScroll = () => {
            setShadow(window.scrollY > 10);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleLogout = () => {
        localStorage.clear();
        navigate("/login", { replace: true });
        window.history.pushState(null, "", "/login");
    };

    const getInitials = (name) => {
        return name
            ?.split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2) || 'U';
    };

    const handleWriteToUs = () => {
        window.location.href = `mailto:${APP_THEME.support?.emailSupport || 'support@example.com'}`;
    };

    const handleRateUs = () => {
        setShowRatingModal(true);
        setSelectedRating(0);
        setHoveredRating(0);
        setFeedbackText("");
    };

    const handleRatingSubmit = () => {
        if (selectedRating >= 4) {
            window.open(APP_THEME.playStoreURL, '_blank', "noopener,noreferrer");
            setShowRatingModal(false);
        } else if (selectedRating >= 1 && selectedRating <= 3) {
            toast.success("Thank you for your feedback!");
            setShowRatingModal(false);
        }
    };

    const handleStarClick = (rating) => {
        setSelectedRating(rating);
        if (rating >= 4) {
            setTimeout(() => {
                window.open(APP_THEME.playStoreURL, '_blank', "noopener,noreferrer");
                setShowRatingModal(false);
            }, 500);
        }
    };


    if (loading) {
        return (
            <>
                <header
                    className="sticky top-0 left-0 w-full right-0 h-14 flex items-center justify-between px-4 z-[950] max-w-full mx-auto transition-shadow duration-200"
                    style={{
                        background: APP_THEME.bgColor,
                        borderBottom: `1px solid ${APP_THEME.borderColor}`,
                    }}
                >
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => navigate(-1)}
                            className="bg-none border-none cursor-pointer p-1 flex items-center"
                        >
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={APP_THEME.textPrimary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="19" y1="12" x2="5" y2="12" />
                                <polyline points="12 19 5 12 12 5" />
                            </svg>
                        </button>
                        <span
                            className="text-base font-semibold"
                            style={{
                                color: APP_THEME.textPrimary,
                                fontFamily: APP_THEME.fontFamily,
                            }}
                        >
                            Profile
                        </span>
                    </div>
                    <div className="w-[22px]" />
                </header>
                <div className="text-center py-12">
                    <div className="w-10 h-10 rounded-full animate-spin mx-auto mb-4" style={{ border: `3px solid ${APP_THEME.primaryColor}33`, borderTopColor: APP_THEME.primaryColor }} />
                    <div className="text-sm font-medium" style={{ color: APP_THEME.textSecondary, fontFamily: APP_THEME.fontFamily }}>
                        Loading profile...
                    </div>
                </div>
                <BottomNav />
                <Toaster position="bottom-center" />
            </>
        );
    }

    return (
        <>
            <header
                className="sticky top-0 left-0 w-full right-0 h-14 flex items-center justify-between px-4 z-[950] max-w-full mx-auto transition-shadow duration-200"
                style={{
                    background: APP_THEME.bgColor,
                    borderBottom: `1px solid ${APP_THEME.borderColor}`,
                    boxShadow: shadow ? "0 2px 8px rgba(0,0,0,0.08)" : "none",
                }}
            >
                <div className="flex items-center gap-3">
                    <button
                        onClick={() => navigate(-1)}
                        className="bg-none border-none cursor-pointer p-1 flex items-center"
                    >
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={APP_THEME.textPrimary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="19" y1="12" x2="5" y2="12" />
                            <polyline points="12 19 5 12 12 5" />
                        </svg>
                    </button>
                    <span
                        className="text-base font-semibold"
                        style={{
                            color: APP_THEME.textPrimary,
                            fontFamily: APP_THEME.fontFamily,
                        }}
                    >
                        Profile
                    </span>
                </div>
                <div>
                    <button
                        onClick={() => navigate("/add-money")}
                        className="bg-transparent cursor-pointer flex items-center gap-2 px-3 h-[38px] rounded-full transition-all duration-200"
                        style={{
                            border: `1.5px solid ${APP_THEME.borderColor}`,
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = APP_THEME.surfaceColor)}
                        onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                    >
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke={APP_THEME.textSecondary}
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M21 7H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1z" />
                            <path d="M16 12h2" />
                            <path d="M5 7V5a2 2 0 0 1 2-2h11" />
                        </svg>
                        <span
                            style={{
                                color: APP_THEME.textPrimary,
                                fontSize: "14px",
                                fontWeight: "600",
                            }}
                        >
                            ₹{balance || "0.00"}
                        </span>
                        <div
                            className="flex items-center justify-center w-5 h-5 rounded-full"
                            style={{
                                background: APP_THEME.primaryColor,
                                color: "#fff",
                            }}
                        >
                            <svg
                                width="12"
                                height="12"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="3"
                                strokeLinecap="round"
                            >
                                <path d="M12 5v14M5 12h14" />
                            </svg>
                        </div>
                    </button>
                </div>
            </header>
            <div className="flex flex-col min-h-[calc(100vh-57px)]">
                {/* Profile Header */}
                <div className="px-4 pt-6 pb-4 flex flex-col items-center">
                    <div
                        className="w-20 h-20 rounded-full flex items-center justify-center text-2xl font-bold mb-3"
                        style={{
                            background: `linear-gradient(135deg, ${APP_THEME.primaryColor}, ${APP_THEME.primaryLight})`,
                            color: '#FFFFFF'
                        }}
                    >
                        {getInitials(profile?.name)}
                    </div>

                    <h2
                        className="text-lg font-bold mb-1"
                        style={{
                            color: APP_THEME.textPrimary,
                            fontFamily: APP_THEME.fontFamily
                        }}
                    >
                        {profile?.name || 'User'}
                    </h2>

                    <p
                        className="text-sm mb-1"
                        style={{
                            color: APP_THEME.textSecondary,
                            fontFamily: APP_THEME.fontFamily
                        }}
                    >
                        {profile?.email || 'No email'}
                    </p>

                    <p
                        className="text-sm mb-4"
                        style={{
                            color: APP_THEME.textSecondary,
                            fontFamily: APP_THEME.fontFamily
                        }}
                    >
                        {profile?.mobile || 'No mobile'}
                    </p>

                    <div className="flex gap-2 w-full max-w-md">
                        <div
                            className="flex-1 px-3 py-2 rounded-lg text-center flex items-center justify-center gap-1.5"
                            style={{
                                background: profile?.mobile_verification === "1"
                                    ? `${APP_THEME.successColor}15`
                                    : `${APP_THEME.warningColor}15`,
                                border: `1px solid ${profile?.mobile_verification === "1"
                                    ? APP_THEME.successColor
                                    : APP_THEME.warningColor}30`
                            }}
                        >
                            {profile?.mobile_verification === "1" ? (
                                <GoVerified size={14} color={APP_THEME.successColor} />
                            ) : (
                                <GoUnverified size={14} color={APP_THEME.warningColor} />
                            )}
                            <p
                                className="text-xs font-medium"
                                style={{
                                    color: profile?.mobile_verification === "1"
                                        ? APP_THEME.successColor
                                        : APP_THEME.warningColor,
                                    fontFamily: APP_THEME.fontFamily
                                }}
                            >
                                Mobile
                            </p>
                        </div>
                        <div
                            className="flex-1 px-3 py-2 rounded-lg text-center flex items-center justify-center gap-1.5"
                            style={{
                                background: profile?.email_verification === "1"
                                    ? `${APP_THEME.successColor}15`
                                    : `${APP_THEME.warningColor}15`,
                                border: `1px solid ${profile?.email_verification === "1"
                                    ? APP_THEME.successColor
                                    : APP_THEME.warningColor}30`
                            }}
                        >
                            {profile?.email_verification === "1" ? (
                                <GoVerified size={14} color={APP_THEME.successColor} />
                            ) : (
                                <GoUnverified size={14} color={APP_THEME.warningColor} />
                            )}
                            <p
                                className="text-xs font-medium"
                                style={{
                                    color: profile?.email_verification === "1"
                                        ? APP_THEME.successColor
                                        : APP_THEME.warningColor,
                                    fontFamily: APP_THEME.fontFamily
                                }}
                            >
                                Email
                            </p>
                        </div>
                        <div
                            className="flex-1 px-3 py-2 rounded-lg text-center flex items-center justify-center gap-1.5"
                            style={{
                                background: profile?.kyc_verification === "1"
                                    ? `${APP_THEME.successColor}15`
                                    : `${APP_THEME.warningColor}15`,
                                border: `1px solid ${profile?.kyc_verification === "1"
                                    ? APP_THEME.successColor
                                    : APP_THEME.warningColor}30`
                            }}
                        >
                            {profile?.kyc_verification === "1" ? (
                                <GoVerified size={14} color={APP_THEME.successColor} />
                            ) : (
                                <GoUnverified size={14} color={APP_THEME.warningColor} />
                            )}
                            <p
                                className="text-xs font-medium"
                                style={{
                                    color: profile?.kyc_verification === "1"
                                        ? APP_THEME.successColor
                                        : APP_THEME.warningColor,
                                    fontFamily: APP_THEME.fontFamily
                                }}
                            >
                                KYC
                            </p>
                        </div>
                    </div>

                    {profile?.kyc_verification !== "1" && (
                        <button
                            onClick={() => navigate('/kyc-verification')}
                            className="w-full max-w-md py-2.5 rounded-lg mt-4 text-sm font-semibold transition-all duration-200 active:scale-98"
                            style={{
                                background: APP_THEME.primaryColor,
                                color: APP_THEME.textOnPrimary,
                                borderRadius: APP_THEME.borderRadiusBtn,
                                fontFamily: APP_THEME.fontFamily,
                                opacity: profile?.kyc_verification === "1" ? 0.6 : 1,
                                cursor: profile?.kyc_verification === "1" ? 'default' : 'pointer'
                            }}
                            disabled={profile?.kyc_verification === "1"}
                        >
                            {profile?.kyc_verification === "1" ? '✅ Verified' : 'Complete Verification'}
                        </button>
                    )}

                    {(profile?.kyc_verification === "1" && profile?.pan_verification !== "1") &&
                        <button
                            onClick={() => navigate('/kyc-verification')}
                            className="w-full max-w-md py-2.5 mt-4 rounded-lg text-sm font-semibold transition-all duration-200 active:scale-98"
                            style={{
                                background: APP_THEME.primaryColor,
                                color: APP_THEME.textOnPrimary,
                                borderRadius: APP_THEME.borderRadiusBtn,
                                fontFamily: APP_THEME.fontFamily,
                                opacity: profile?.pan_verification === "1" ? 0.6 : 1,
                                cursor: profile?.pan_verification === "1" ? 'default' : 'pointer'
                            }}
                            disabled={profile?.pan_verification === "1"}
                        >
                            {profile?.pan_verification === "1" ? '✅ Verified' : 'PAN Verification'}
                        </button>
                    }
                </div>

                <div
                    className="mx-4"
                    style={{
                        borderBottom: `1px solid ${APP_THEME.borderColor}`
                    }}
                />

                {/* Other Features Section */}
                <div className="my-2">
                    <h1 className="text-md px-4 font-semibold py-2" style={{ color: APP_THEME.textSecondary }}>
                        Other Features
                    </h1>
                    <div 
                        className="flex-1 mx-4 px-4 pt-2 rounded-xl"
                        style={{ background: APP_THEME.surfaceColor }}
                    >
                        {menuItems.map((item, index) => (
                            <div
                                key={`menu-${item.path}-${index}`}
                                onClick={() => {
                                    if (item.label === "Write to Us") {
                                        handleWriteToUs();
                                    } else if (item.label === "Rate Us") {
                                        handleRateUs();
                                    } else {
                                        navigate(item.path);
                                    }
                                }}
                                className="flex items-center gap-3.5 py-3.5 cursor-pointer transition-all duration-200 active:scale-98"
                                style={{
                                    borderBottom: index < menuItems.length - 1 ? `1px solid ${APP_THEME.borderColor}` : "none",
                                }}
                            >
                                <div
                                    className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
                                    style={{ background: APP_THEME.primaryLight }}
                                >
                                    {item.icon(APP_THEME.primaryColor)}
                                </div>
                                <span
                                    className="flex-1 text-sm font-medium"
                                    style={{ color: APP_THEME.textPrimary, fontFamily: APP_THEME.fontFamily }}
                                >
                                    {item.label}
                                </span>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={APP_THEME.textSecondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="9 18 15 12 9 6" />
                                </svg>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Policies Section */}
                <div className="my-2">
                    <h1 className="text-md px-4 font-semibold py-2" style={{ color: APP_THEME.textSecondary }}>
                        Policies
                    </h1>
                    <div 
                        className="flex-1 mx-4 px-4 pt-2 rounded-xl"
                        style={{ background: APP_THEME.surfaceColor }}
                    >
                        {policyItems.map((item, index) => (
                            <a
                                href={item.url} target="_blank" rel="noopener noreferrer"
                                key={`policy-${item.id}-${index}`}
                                className="flex items-center gap-3.5 py-3.5 cursor-pointer transition-all duration-200 active:scale-98"
                                style={{
                                    borderBottom: index < policyItems.length - 1 ? `1px solid ${APP_THEME.borderColor}` : "none",
                                }}
                            >
                                <div
                                    className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0"
                                    style={{ background: APP_THEME.primaryLight }}
                                >
                                    <span style={{ color: APP_THEME.primaryColor }}>
                                        {item.icon}
                                    </span>
                                </div>
                                <div className="flex-1">
                                    <span
                                        className="text-sm font-medium block"
                                        style={{ color: APP_THEME.textPrimary, fontFamily: APP_THEME.fontFamily }}
                                    >
                                        {item.label}
                                    </span>
                                    <span
                                        className="text-xs"
                                        style={{ color: APP_THEME.textTertiary, fontFamily: APP_THEME.fontFamily }}
                                    >
                                        {item.description}
                                    </span>
                                </div>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={APP_THEME.textSecondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="9 18 15 12 9 6" />
                                </svg>
                            </a>
                        ))}
                    </div>
                </div>


                {/* Logout Button */}
                <div className="px-4 pb-6 pt-2 mt-4">
                    <button
                        onClick={() => setShowLogoutModal(true)}
                        className="w-full py-3.5 rounded-xl flex items-center justify-center gap-2.5 transition-all duration-200 active:scale-98"
                        style={{
                            background: `${APP_THEME.errorColor}10`,
                            border: `1px solid ${APP_THEME.errorColor}30`,
                        }}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={APP_THEME.errorColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                            <polyline points="16 17 21 12 16 7" />
                            <line x1="21" y1="12" x2="9" y2="12" />
                        </svg>
                        <span
                            className="text-sm font-semibold"
                            style={{ color: APP_THEME.errorColor, fontFamily: APP_THEME.fontFamily }}
                        >
                            Logout
                        </span>
                    </button>
                </div>

                <AppFooter />
            </div>
            <BottomNav />

            {/* Rating Modal */}
            {showRatingModal && (
                <div className="fixed inset-0 bg-black/50 flex items-end justify-center z-[1100] animate-fadeIn">
                    <div
                        className="w-full max-w-md p-6 rounded-t-2xl animate-slideUp"
                        style={{
                            background: APP_THEME.bgColor,
                            borderRadius: `${APP_THEME.borderRadiusCard} ${APP_THEME.borderRadiusCard} 0 0`,
                            maxHeight: '80vh',
                            overflowY: 'auto'
                        }}
                    >
                        <div className="w-12 h-1 rounded-full mx-auto mb-4" style={{ background: APP_THEME.borderColor }} />

                        <h3
                            className="text-lg font-bold text-center mb-2"
                            style={{ color: APP_THEME.textPrimary, fontFamily: APP_THEME.fontFamily }}
                        >
                            Rate Us
                        </h3>
                        <p
                            className="text-sm text-center mb-6"
                            style={{ color: APP_THEME.textSecondary, fontFamily: APP_THEME.fontFamily }}
                        >
                            How would you rate your experience?
                        </p>

                        <div className="flex justify-center gap-3 mb-6">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <button
                                    key={star}
                                    onClick={() => handleStarClick(star)}
                                    onMouseEnter={() => setHoveredRating(star)}
                                    onMouseLeave={() => setHoveredRating(0)}
                                    className="text-4xl transition-all duration-200 transform hover:scale-110"
                                    style={{
                                        color: (hoveredRating || selectedRating) >= star
                                            ? '#FFB800'
                                            : APP_THEME.borderColor,
                                    }}
                                >
                                    ★
                                </button>
                            ))}
                        </div>

                        {selectedRating >= 1 && selectedRating <= 3 && (
                            <div className="mb-6">
                                <textarea
                                    placeholder="Please tell us how we can improve..."
                                    value={feedbackText}
                                    onChange={(e) => setFeedbackText(e.target.value)}
                                    className="w-full p-3 rounded-lg text-sm resize-none"
                                    rows="4"
                                    style={{
                                        background: APP_THEME.surfaceColor,
                                        color: APP_THEME.textPrimary,
                                        border: `1px solid ${APP_THEME.borderColor}`,
                                        fontFamily: APP_THEME.fontFamily,
                                        outline: 'none'
                                    }}
                                />
                                <button
                                    onClick={handleRatingSubmit}
                                    className="w-full mt-2 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 active:scale-98"
                                    style={{
                                        background: APP_THEME.primaryColor,
                                        color: APP_THEME.textOnPrimary,
                                        borderRadius: APP_THEME.borderRadiusBtn,
                                        fontFamily: APP_THEME.fontFamily,
                                    }}
                                >
                                    Submit Feedback
                                </button>
                            </div>
                        )}

                        <button
                            onClick={() => setShowRatingModal(false)}
                            className="w-full py-2.5 rounded-lg text-sm font-medium transition-all duration-200 active:scale-98"
                            style={{
                                background: APP_THEME.surfaceColor,
                                color: APP_THEME.textSecondary,
                                border: `1px solid ${APP_THEME.borderColor}`,
                                borderRadius: APP_THEME.borderRadiusBtn,
                                fontFamily: APP_THEME.fontFamily,
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}

            {/* Logout Modal */}
            {showLogoutModal && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[1100] animate-fadeIn">
                    <div
                        className="w-[calc(100%-48px)] max-w-[320px] p-6 rounded-card text-center animate-scaleIn"
                        style={{
                            background: APP_THEME.bgColor,
                            borderRadius: APP_THEME.borderRadiusCard
                        }}
                    >
                        <h3
                            className="text-lg font-bold mb-2"
                            style={{ color: APP_THEME.textPrimary, fontFamily: APP_THEME.fontFamily }}
                        >
                            Logout
                        </h3>
                        <p
                            className="text-sm mb-6"
                            style={{ color: APP_THEME.textSecondary, fontFamily: APP_THEME.fontFamily }}
                        >
                            Are you sure you want to logout?
                        </p>
                        <div className="flex gap-3">
                            <button
                                onClick={() => setShowLogoutModal(false)}
                                className="flex-1 h-11 border rounded-lg text-sm font-semibold cursor-pointer transition-all duration-200 active:scale-98"
                                style={{
                                    background: APP_THEME.surfaceColor,
                                    color: APP_THEME.textPrimary,
                                    borderColor: APP_THEME.borderColor,
                                    borderRadius: APP_THEME.borderRadiusBtn,
                                    fontFamily: APP_THEME.fontFamily,
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleLogout}
                                className="flex-1 h-11 border-none rounded-lg text-sm font-semibold cursor-pointer transition-all duration-200 active:scale-98"
                                style={{
                                    background: APP_THEME.errorColor,
                                    color: APP_THEME.textOnPrimary,
                                    borderRadius: APP_THEME.borderRadiusBtn,
                                    fontFamily: APP_THEME.fontFamily,
                                }}
                            >
                                Logout
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Toaster position="bottom-center" />
            <style>
                {`
                    .active\\:scale-98:active {
                        transform: scale(0.98);
                    }
                    @keyframes fadeIn {
                        from { opacity: 0; }
                        to { opacity: 1; }
                    }
                    @keyframes scaleIn {
                        from { 
                            opacity: 0;
                            transform: scale(0.9);
                        }
                        to { 
                            opacity: 1;
                            transform: scale(1);
                        }
                    }
                    @keyframes slideUp {
                        from {
                            transform: translateY(100%);
                            opacity: 0;
                        }
                        to {
                            transform: translateY(0);
                            opacity: 1;
                        }
                    }
                    .animate-fadeIn {
                        animation: fadeIn 0.2s ease forwards;
                    }
                    .animate-scaleIn {
                        animation: scaleIn 0.2s ease forwards;
                    }
                    .animate-slideUp {
                        animation: slideUp 0.3s ease forwards;
                    }
                    .animate-spin {
                        animation: spin 1s linear infinite;
                    }
                    @keyframes spin {
                        from {
                            transform: rotate(0deg);
                        }
                        to {
                            transform: rotate(360deg);
                        }
                    }
                `}
            </style>
        </>
    );
}

export default ProfileDetails;